module.exports = __webpack_public_path__ + "img/mxn.ca61bc6c.svg";